var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSandvichCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.185 15.945L23.635 9.49501C23.975 9.15501 23.975 8.595 23.635 8.255C23.295 7.915 22.735 7.915 22.395 8.255L15.945 14.705L9.49499 8.255C9.15499 7.915 8.595 7.915 8.255 8.255C7.915 8.595 7.915 9.15501 8.255 9.49501L14.705 15.945L8.255 22.395C7.915 22.735 7.915 23.295 8.255 23.635C8.595 23.975 9.15499 23.975 9.49499 23.635L15.945 17.185L22.395 23.635C22.735 23.975 23.295 23.975 23.635 23.635C23.975 23.295 23.975 22.735 23.635 22.395L17.185 15.945Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandvichCross);
export default __webpack_public_path__ + "static/media/Sandvich_Cross.54d22ffc2cfa0db1d2a61bc9115852b0.svg";
export { ForwardRef as ReactComponent };